import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { VideoItemComponent } from 'src/app/@core/models/item-component';

@Component({
  selector: 'app-editor-component-video',
  templateUrl: 'video.component.html'
})
export class EditorVideoComponent implements OnChanges {
  @Input() item: VideoItemComponent;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.item && this.item) {
      // this.item.showVideoControl = true;
    }
  }

}
